import { useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
const OnCallManagement = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.OnCallManagement.header",
            defaultMessage: "On-call management"
        }),
        body: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.OnCallManagement.body",
                defaultMessage:
                    "<p>Create routing rules, escalation policies, and on-call schedules to manage who is notified of alerts.</p><p>Premium and Enterprise plans include:</p>"
            },
            {
                ...DEFAULT_VALUES
            }
        ),
        listItems: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.OnCallManagement.listItems",
                defaultMessage:
                    "<li>Multiple routing rules per team</li> <li>Advanced escalation steps (like notifying next user in schedule)</li>"
            },
            {
                li: (chunk: React.ReactNode) => <li>{chunk}</li>
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <ul>{messages.listItems}</ul>
        </>
    );
};

export default OnCallManagement;
